import APIHandler from "api/api-handler";
import fileUploadApi from "api/file-upload-api";

import { API_ROUTES } from "./const";

export const fetchErrorReport = ({ retailerId }: { retailerId: string }) =>
  APIHandler.get({
    url: API_ROUTES.CONNECTION.ERROR_REPORT(retailerId)
  });

interface IUpdateConnectionResourceStatusesParams {
  ids: string[];
  status: "PENDING" | "REMOVED";
  retailer: number;
}

export const updateConnectionResourceStatuses = ({ ids, status, retailer }: IUpdateConnectionResourceStatusesParams) =>
  APIHandler.patch({
    url: API_ROUTES.CONNECTION.BULK_UPDATE_CONNECTION_RESOURCES_STATUS,
    body: { ids, status, retailer }
  });

export const uploadErrorReportImages = async ({
  connectionId,
  files
}: {
  connectionId: string;
  files: File[];
}) => {
  const s3Urls = await Promise.allSettled(files.map(async (file): Promise<string> => {
    const { url } = await fileUploadApi.getUploadUrl(file);
    await fileUploadApi.s3FileUpload(url, file);
    const urlWithoutQueryParams = url.split("?")[0];
    return urlWithoutQueryParams;
  }));

  // eslint-disable-next-line unicorn/no-array-reduce
  const validUrls = s3Urls.reduce((acc, url) => {
    if (url.status === "fulfilled" && url.value) {
      return [...acc, url.value];
    }
    return acc;
  }, [] as string[]);

  if (validUrls.length === 0) {
    throw new Error("Uploads failed");
  }

  return APIHandler.post({
    url: API_ROUTES.CONNECTION.ADD_ERROR_REPORT_IMAGES(connectionId),
    // eslint-disable-next-line @typescript-eslint/naming-convention
    body: { image_urls: validUrls }
  });
};

export const fetchEnhancingListings = ({ retailerId }: { retailerId: string }) => APIHandler.get({ url: API_ROUTES.CONNECTION.ENHANCING, retailerId });
